import { RolodexEntryJson } from 'types'
import { GeckoEntryBase } from 'types/entries/geckoEntry'
import { parseString } from 'utils/parsingHelpers'

/**
 * An entry for various photogrammetry representations of a component.
 *
 * A single model should represent a collection of textures / 3D models / links
 *  that were produced from the same set of images (one photogrammetry 'inspection').
 */
export interface KVCameraPoseCalibration {
  k1: number
  k2: number
  k3: number
  k4: number
  t1: number
  t2: number
  name: string
  width: number
  height: number
  center_x: number
  center_y: number
  cam_location: [number, number, number]
  focal_length_x: number
  focal_length_y: number
  rotation_matrix: [
    [number, number, number],
    [number, number, number],
    [number, number, number],
  ]
}

/** Camera poses keyed by image filename. */
export type KVCameraPosesByFilename = Record<string, KVCameraPoseCalibration>

export class GeckoKestrelModelCameras extends GeckoEntryBase<
  {
    cameraPoses: KVCameraPosesByFilename
  },
  {
    'kestrel-model': string
  }
> {
  private constructor(json: RolodexEntryJson) {
    const recordData = json.data as Record<string, unknown>

    const raw = recordData.cameraPoses
    const cameraPoses: KVCameraPosesByFilename =
      raw !== null && typeof raw === 'object' && !Array.isArray(raw)
        ? (raw as KVCameraPosesByFilename)
        : {}

    super(
      json,
      {
        cameraPoses,
      },
      {
        'kestrel-model': parseString(json.tags.organization) ?? '',
      },
      {}
    )
  }

  public static CreateFromJSON(json: RolodexEntryJson) {
    return new GeckoKestrelModelCameras(json)
  }
}
